import { useEffect, useRef} from "react";
import { consumer } from "../../helpers/consumer";
import useActiveTab from "./useActiveTab";

export default function useChannel(setNotifications, setActivePulse, loaded, lastRefresh, updateLastRefresh, componentRef) {
  const pingInterval = useRef(null);
  const subscription = useRef(null);
  const activeTab = useActiveTab();


  const onTabBlur = () => {
    if (activeTab) return;
    disconnectChannel();
  }

  const disconnectChannel = () => {
    clearInterval(pingInterval.current);
    if (subscription.current){
      consumer.subscriptions.remove(subscription.current);
    }
  }

  const initChannel = () => {
    if (!activeTab) return;
    if (!loaded) return;
    // Prevent memory leak if component unmount and several setState still calling
    if (!componentRef){
      disconnectChannel();
      return;
    }
    subscription.current = consumer.subscriptions.create(
      { channel: 'LongRunningTaskChannel' },
      {
        connected() {
          this.refreshNotifications();
          pingInterval.current = setInterval(() => {
            subscription.current.send({command: 'refresh'})
          }, 10 * 1000);
        },

        disconnected() {
          // Just to ensure as this doesn't seem to always get called
          clearInterval(pingInterval.current);
        },

        received(data) {
          const newData = Array.isArray(data) ? data : [data];

          updateLastRefresh(newData);

          setNotifications(currentNotifications => {
            const existingIds = new Set(currentNotifications.map(item => item.id));
          
            const updatedNotifications = currentNotifications.map(notification => {
              const newItem = newData.find(newItem => newItem.id === notification.id)
              if (newItem) { 
                if (newItem.status == 'completed' && !existingIds.has(newItem.id)) {
                  setActivePulse(true);
                }
                return newItem;
              }
              return notification;
            })
          
            const addedNotifications = newData.filter(newItem => !existingIds.has(newItem.id));
          
            if (addedNotifications.length > 0) {
              setActivePulse(true);
            }

            return [...addedNotifications, ...updatedNotifications];
          });
        },

        refreshNotifications: () => {
          subscription.current.send({ command: 'refresh', changesSince: lastRefresh.current });
        },
      }
    );

    return disconnectChannel;
  }

  useEffect(initChannel, [activeTab, loaded]);
  useEffect(onTabBlur, [activeTab, loaded])

  return;
}